var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-app',{staticClass:"a-app"},[(_vm.token)?[_c('router-view')]:[_c('TheAccessDenied')]],2)}
var staticRenderFns = []

export { render, staticRenderFns }